import React from "react";
import {Input} from "reactstrap";
import {Field} from 'react-final-form';
import {DateTimePicker} from "@material-ui/pickers";
import {getDatePickerProps, numberWithCommas, stringToNumber} from "./Utils";
import {composeValidators, mustBeInteger, mustBeNumber, required} from "./Validators";
import FieldError from "../components/FieldError";
import TextField from "../components/TextField";
import i18n from "../services/i18n";
import Switch from "react-switch";
import Select from "react-select";

const SelectAdapter = ({input, ...rest}) => (
  <Select
    {...input}
    {...rest}
    placeholder={i18n.t('Select')}
  />
);

const MultiSelectAdapter = ({input, ...rest}) => (
  <Select
    {...input}
    {...rest}
    isMulti
    placeholder={i18n.t('Select')}
    closeMenuOnSelect={false}
  />
);

export const getField = (type, props) => {
  const {name, label, ...otherProps} = props;
  if (type === "string" || type === "text" || type === "textarea") {
    return (
      <TextField
        item={{
          name,
          i18n: label,
          required: props.required,
          type: type === "textarea" ? 'textarea' : 'text',
          ...otherProps,
        }}
      />
    );
  }
  if (type === "select") {
    return (
      <div>
        <span>
          {label}
          {props.required ? <span className="required">*</span> : ''}
        </span>
        <Field
          name={name}
          component={otherProps.isMulti ? MultiSelectAdapter : SelectAdapter}
          validate={props.required ? required : () => undefined}
          {...otherProps}
        />
        <FieldError name={name}/>
      </div>
    );
  }
  return (
    <Field
      name={name}
      validate={composeValidators(
        props.required ? required : () => undefined,
        type === "int" || type === "decimal" ? mustBeNumber : () => undefined,
        type === "int" ? mustBeInteger : () => undefined,
      )}>
      {({input}) => {
        const {required, label, name, ...otherProps} = props;
        if (type === "datetime") {
          return (
            <div>
              <span>
                {label}
                {required ? <span className="required">*</span> : ''}
              </span>
              <DateTimePicker
                {...getDatePickerProps()}
                TextFieldComponent={props =>
                  <Input
                    style={{width: '100%'}}
                    placeholder={i18n.t('Select')}
                    {...props}
                  />
                }
                minDate={undefined}
                maxDate={undefined}
                value={input.value ? input.value : null}
                onChange={date => {input.onChange(date);}}
                {...otherProps}
              />
            </div>
          );
        }
        if (type === "int" || type === "decimal") {
          return (
            <div>
              <span>
                {label}
                {required ? <span className="required">*</span> : ''}
              </span>
              <Input
                value={numberWithCommas(input.value)}
                onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                {...otherProps}
              />
              <FieldError name={name}/>
            </div>
          );
        }
        if (type === "boolean") {
          return (
            <Switch
              className="ltr"
              onChange={enabled => {input.onChange(enabled);}}
              checked={input.value}
              height={22}
              width={45}
            />
          );
        }
        return null;
      }}
    </Field>
  )
};
